import * as THREE from "three";

/**
 * Dispose every entry in a datum's 2D / 3D sub-element maps: drops GPU
 * geometry + materials, detaches from parent, and clears the maps.
 */
export function disposeSubElements(
  subElements2D: Map<string, THREE.Object3D>,
  subElements3D: Map<string, THREE.Object3D>,
): void {
  for (const map of [subElements2D, subElements3D]) {
    for (const obj of map.values()) {
      const mesh = obj as THREE.Mesh;
      if (mesh.geometry) mesh.geometry.dispose();
      if (Array.isArray(mesh.material)) {
        mesh.material.forEach((mat) => mat.dispose());
      } else if (mesh.material) {
        (mesh.material as THREE.Material).dispose();
      }
      mesh.removeFromParent();
    }
    map.clear();
  }
}
